import React from 'react';
import { MdAdd } from 'react-icons/md';

export const CreateTriggerBtn = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="bg-1 flex items-center gap-3 rounded-xl px-4 py-2 text-sm font-light"
    >
      <MdAdd />
      Create Workflow
    </button>
  );
};

export default CreateTriggerBtn;
